export default function ChooseRole({ setFlow }) {
  return (
    <div className="flex w-full h-full items-center justify-center">
      <div className="flex flex-col items-center gap-8">
        <span className="text-lg lg:text-3xl font-black mb-6 lg:mb-16 text-text-hard dark:text-white">نقش کاربری خود را مشخص کنید</span>
        <div className="grid grid-cols-2 w-full lg:w-fit items-center justify-center gap-6 lg:gap-10 px-4">
          <button
            onClick={() => setFlow({ step: 3, role: 'realestate' })}
            className="w-full aspect-square lg:w-[200px] lg:h-[180px] rounded-xl border-2 text-base lg:text-xl font-semibold flex flex-col gap-6 items-center justify-center border-primary/80 hover:bg-secondary text-primary transition-all"
          >
            <svg
              className="w-7 h-7 lg:w-10 lg:h-10 fill-current"
              version="1.1"
              id="Layer_1"
              viewBox="0 0 512.001 512.001"
            >
              <g>
                <g>
                  <path
                    d="M507.111,255.326l-50.763-50.763V94.609c0-9.22-7.475-16.696-16.696-16.696H372.87c-9.22,0-16.696,7.475-16.696,16.696
			v9.78L267.805,16.02c-6.519-6.519-17.091-6.519-23.611,0C238.116,22.099,13.778,246.436,4.89,255.325
			c-6.52,6.519-6.52,17.091,0,23.611c6.519,6.519,17.091,6.519,23.611,0l27.152-27.15v232.389c0,9.22,7.475,16.696,16.696,16.696
			h367.304c9.22,0,16.696-7.475,16.696-16.696V251.785l27.152,27.152c6.52,6.52,17.091,6.52,23.611,0
			C513.631,272.418,513.631,261.846,507.111,255.326z M422.957,467.479H89.044V218.394L256.001,51.437
			c8.681,8.681,158.347,158.347,166.957,166.957V467.479z M422.957,171.172l-33.391-33.391v-26.476h33.391V171.172z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <circle cx="205.914" cy="261.566" r="16.696" />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M373.545,355.5l-16.696-16.697c-3.131-3.131-7.377-4.89-11.805-4.89h-22.261v-22.261c0-4.429-1.759-8.675-4.891-11.805
			l-29.065-29.066c0.377-3.129,0.564-6.185,0.564-9.215c0-46.03-37.448-83.478-83.478-83.478s-83.478,37.448-83.478,83.478
			s37.448,83.478,83.478,83.478c3.031,0,6.088-0.186,9.216-0.564l84.717,84.717c3.131,3.131,7.378,4.89,11.806,4.89h50.087
			c9.22,0,16.696-7.475,16.696-16.696v-50.087C378.435,362.876,376.676,358.63,373.545,355.5z M345.044,400.696h-26.476
			l-85.956-85.956c-4.063-4.061-9.926-5.749-15.527-4.471c-4.067,0.93-7.721,1.383-11.172,1.383
			c-27.618,0-50.087-22.469-50.087-50.087c0-27.618,22.469-50.087,50.087-50.087c27.618,0,50.087,22.469,50.087,50.087
			c0,3.45-0.452,7.106-1.382,11.173c-1.28,5.6,0.408,11.464,4.471,15.526l30.303,30.304v32.041c0,9.22,7.475,16.696,16.696,16.696
			h32.041l6.915,6.915V400.696z"
                  />
                </g>
              </g>
            </svg>
            <span>مدیر املاک</span>
          </button>
          <button
            onClick={() => setFlow({ step: 3, role: 'agent' })}
            className="w-full aspect-square lg:w-[200px] lg:h-[180px] rounded-xl border-2 text-base lg:text-xl font-semibold flex flex-col gap-6 items-center justify-center border-primary/80 hover:bg-secondary text-primary transition-all"
          >
            <svg
              className="w-7 h-7 lg:w-10 lg:h-10 text-current"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle stroke="currentColor" cx="12" cy="7" r="4" strokeWidth="2" strokeLinecap="round" />
              <path
                stroke="currentColor"
                d="M5.33788 18.3206C5.99897 15.5269 8.77173 14 11.6426 14H12.3574C15.2283 14 18.001 15.5269 18.6621 18.3206C18.79 18.8611 18.8917 19.4268 18.9489 20.0016C19.0036 20.5512 18.5523 21 18 21H6C5.44772 21 4.99642 20.5512 5.0511 20.0016C5.1083 19.4268 5.20997 18.8611 5.33788 18.3206Z"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            <span>مشاور املاک</span>
          </button>
        </div>
        <span className="text-blackFont-600 text-sm text-center">
          با انتخاب نقش کاربری صحیح به مجموعه ای از امکانات ویژگی های منتاسب با نقش و نیاز خود دست پیدا کنید
        </span>
      </div>
    </div>
  );
}
